<template>
  <div v-if="value || this.$slots.default" class="info-row">
    <p>{{ label }}</p>
    <div class="values">
      <slot>
        <p>{{value}}</p>
      </slot>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      label: {
        type: String,
        default: ''
      },
      value: {
        type: String,
        default: ''
      },
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../scss/_colors.scss";
  .info-row {
    .values {
      margin-top: 5px;
      p {
        color: $black;
        text-transform: none;
        margin-bottom: 4px;
        font-weight: 500;
      }
    }
    p {
      font-weight: 600;
      font-size: 17px;
      color: $dark-blue-2;
      margin: 0;
      text-align: initial;
      text-transform: capitalize;
    }
  }

</style>
